import React from 'react';
import { Fade } from '@mui/material';
import { FadeProps } from '@mui/material/Fade';

export default React.forwardRef<unknown, FadeProps>(
  /* eslint-disable react/jsx-props-no-spreading */
  (props, ref) => <Fade ref={ref} {...props} />,
);
